import React, { useState, useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";
import { useAuth } from "../context/AuthContext";
import { RingLoader } from "react-spinners";

const Transactions = () => {
  const { currentUser } = useAuth();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  // Format Firestore timestamp to a readable date and time.
  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "N/A";
    const date = timestamp.toDate();
    return date.toLocaleString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  // Real-time listener on the current user's document for wallet transactions.
  useEffect(() => {
    if (!currentUser) return;
    const userDocRef = doc(db, "users", currentUser.uid);
    const unsubscribe = onSnapshot(userDocRef, (docSnapshot) => {
      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        setTransactions(data.wallet?.transactions || []);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [currentUser]);

  return (
    <div className="min-h-screen flex flex-col items-center bg-gray-50 dark:bg-gray-900 p-6 transition-colors duration-300">
      <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-6">
        📊 Your Transactions
      </h2>

      {loading ? (
        <div className="flex justify-center items-center">
          <RingLoader color="#4B5563" size={50} />
        </div>
      ) : transactions.length === 0 ? (
        <p className="text-gray-500 dark:text-gray-300 text-lg">No transactions found.</p>
      ) : (
        <div className="w-full max-w-4xl bg-white dark:bg-gray-800 p-6 shadow-lg rounded-xl">
          <table className="w-full text-left">
            <thead>
              <tr className="border-b border-gray-300 dark:border-gray-700">
                <th className="py-2 text-gray-800 dark:text-white">Type</th>
                <th className="py-2 text-gray-800 dark:text-white">Amount</th>
                <th className="py-2 text-gray-800 dark:text-white">Date & Time</th>
              </tr>
            </thead>
            <tbody>
              {transactions
                .slice()
                .reverse()
                .map((transaction, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-300 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200"
                  >
                    <td className="py-3 text-gray-700 dark:text-gray-300 capitalize">
                      {transaction.type}
                    </td>
                    <td
                      className={`py-3 ${
                        transaction.type === "deposit" ? "text-green-600" : "text-red-600"
                      }`}
                    >
                      {transaction.type === "deposit" ? "+" : "-"} ₹
                      {Math.abs(transaction.amount).toFixed(2)}
                    </td>
                    <td className="py-3 text-gray-700 dark:text-gray-300">
                      {formatTimestamp(transaction.timestamp)}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Transactions;
